/**
 * Resolve paths to files in Vite `public/` so they work with:
 * - `base: './'`
 * - BrowserRouter nested routes in DEV (absolute from origin)
 * - HashRouter in PROD (URL API ignores the hash when resolving)
 * Never pass Windows filesystem paths here.
 */
export function publicUrl(assetPath: string): string {
  if (!assetPath) return ''
  // Callers may already provide a resolved same-origin or CDN URL.
  if (/^https?:\/\//i.test(assetPath)) return assetPath
  // Reject accidental Windows paths
  if (/^[A-Za-z]:[\\/]/.test(assetPath) || assetPath.startsWith('\\\\')) {
    console.warn('Rejected Windows path in publicUrl:', assetPath)
    return ''
  }
  const cleaned = assetPath.replace(/^\/+/, '')
  if (import.meta.env.DEV) {
    return `/${cleaned}`
  }
  const base = import.meta.env.BASE_URL || './'
  try {
    return new URL(`${base}${cleaned}`, window.location.href).href
  } catch {
    return `${base}${cleaned}`
  }
}
